<ion-content *transloco="let t; read: 'ONBOARDING_MODAL_COMPONENT'">
  <div class="onboarding-inner">
    <ng-container *ngIf="onboardingInfos.length > 0">
      <swiper
        #swiper
        (slideChangeTransitionEnd)="onSlideChangeTransitionEnd($event)"
        [pagination]="{ dynamicBullets: true, dynamicMainBullets: 3 }"
        [centeredSlides]="true"
        [initialSlide]="sliderOptions.initialSlide"
      >
        [spaceBetween]="10">
        <ng-container *ngFor="let onboardingScreen of onboardingInfos">
          <ng-template swiperSlide>
            <div class="onboarding-slide">
              <div class="spacer"></div>
              <app-onboarding [data]="onboardingScreen"></app-onboarding>
            </div>
          </ng-template>
        </ng-container>
      </swiper>
      <div class="spacer"></div>

      <ng-container>
        <div class="buttons" *ngIf="!swiperIsEnd && onboardingInfos.length > 1">
          <div class="text-clickable mt-16" (click)="dismissModal()">{{ t('SKIP') }}</div>
          <div class="success-color text-clickable mt-16" (click)="slideNext()">{{ t('NEXT') }}</div>
        </div>
        <div class="buttons" *ngIf="swiperIsEnd || onboardingInfos.length === 1">
          <div class="spacer"></div>
          <div class="success-color text-clickable mt-16" (click)="dismissModal()">{{ t('BEGIN') }}</div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ion-content>
